/**
 * DevExtreme (renovation/ui/scheduler/workspaces/base/virtual-row.js)
 * Version: 20.2.13
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
exports.VirtualRow = VirtualRow;
exports.viewFunction = exports.VirtualRowProps = void 0;
var _utils = require("../utils");
var _row = require("./row");
var _virtualCell = require("./virtual-cell");
var Preact = _interopRequireWildcard(require("preact"));
var _hooks = require("preact/hooks");
var _excluded = ["cellsCount", "children", "className", "height"];
function _getRequireWildcardCache(nodeInterop) {
  if ("function" !== typeof WeakMap) {
    return null;
  }
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if ("default" !== key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _objectWithoutProperties(source, excluded) {
  if (null == source) {
    return {};
  }
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) {
        continue;
      }
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
        continue;
      }
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (null == source) {
    return {};
  }
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) {
      continue;
    }
    target[key] = source[key];
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) {
    return;
  }
  if ("string" === typeof o) {
    return _arrayLikeToArray(o, minLen);
  }
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if ("Object" === n && o.constructor) {
    n = o.constructor.name;
  }
  if ("Map" === n || "Set" === n) {
    return Array.from(o);
  }
  if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
    return _arrayLikeToArray(o, minLen);
  }
}
function _iterableToArray(iter) {
  if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
    return Array.from(iter);
  }
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    return _arrayLikeToArray(arr);
  }
}
function _arrayLikeToArray(arr, len) {
  if (null == len || len > arr.length) {
    len = arr.length;
  }
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return "symbol" === _typeof(key) ? key : String(key);
}
function _toPrimitive(input, hint) {
  if ("object" !== _typeof(input) || null === input) {
    return input;
  }
  var prim = input[Symbol.toPrimitive];
  if (void 0 !== prim) {
    var res = prim.call(input, hint || "default");
    if ("object" !== _typeof(res)) {
      return res;
    }
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === hint ? String : Number)(input);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var viewFunction = function (viewModel) {
  return Preact.h(_row.Row, _extends({}, viewModel.restAttributes, {
    style: viewModel.style,
    className: viewModel.classes
  }), viewModel.virtualCells.map(function (_, index) {
    return Preact.h(_virtualCell.VirtualCell, {
      key: index.toString()
    });
  }));
};
exports.viewFunction = viewFunction;
var VirtualRowProps = _objectSpread(_objectSpread({}, _row.RowProps), {}, {
  cellsCount: 1
});
exports.VirtualRowProps = VirtualRowProps;
function VirtualRow(props) {
  var __style = (0, _hooks.useCallback)(function () {
    var height = props.height;
    var _restAttributes = __restAttributes(),
      style = _restAttributes.style;
    return (0, _utils.addHeightToStyle)(height, style);
  }, [props.height]);
  var __classes = (0, _hooks.useCallback)(function () {
    var className = props.className;
    return "dx-scheduler-virtual-row ".concat(className);
  }, [props.className]);
  var __virtualCells = (0, _hooks.useCallback)(function () {
    var cellsCount = props.cellsCount;
    return _toConsumableArray(Array(cellsCount));
  }, [props.cellsCount]);
  var __restAttributes = (0, _hooks.useCallback)(function () {
    var restProps = (props.cellsCount, props.children, props.className, props.height, _objectWithoutProperties(props, _excluded));
    return restProps;
  }, [props]);
  return viewFunction({
    props: _objectSpread({}, props),
    style: __style(),
    classes: __classes(),
    virtualCells: __virtualCells(),
    restAttributes: __restAttributes()
  });
}
VirtualRow.defaultProps = _objectSpread({}, VirtualRowProps);